import styled from 'styled-components';

import { colors, responsive } from '@/utils';

/** Takes the surrounding font, so it matches the text it replaces. */
export const StyledInlineEditInput = styled.input`
  width: 100%;
  min-width: 0;
  border: 1px solid ${colors.stroke.focused};
  border-radius: ${responsive.radius.small};
  background: ${colors.surface.default};
  color: ${colors.text.neutral[100]};
  font: inherit;
  padding: 0 ${responsive.spacing.xsmall};

  &[aria-invalid='true'] {
    border-color: ${colors.stroke.critical.soft[100]};
  }
`;
